import { PlanType } from '@labrav/react-components'

export enum PaymentType {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  ANNUALLY = 'ANNUALLY',
  CUSTOM = 'CUSTOM',
}

export const GcpPostPaymentTypes = [
  PaymentType.MONTHLY,
  PaymentType.QUARTERLY,
  PaymentType.ANNUALLY,
]

export enum ScheduleType {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
  CUSTOM = 'CUSTOM',
}

export enum DurationType {
  MONTHS = 'MONTHS',
  YEARS = 'YEARS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
}

export enum OfferStatus {
  PRIVATE_OFFER_CREATION_IN_PROGRESS = 'OFFER_CREATION_IN_PROGRESS',
  PRIVATE_OFFER_EMAIL_SENT = 'OFFER_EMAIL_SENT',
  PRIVATE_OFFER_VIEWED = 'OFFER_VIEWED',
  PRIVATE_OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  PRIVATE_OFFER_EXPIRED = 'OFFER_EXPIRED',
  PRIVATE_OFFER_FAILED = 'OFFER_CREATION_FAILED',
  PRIVATE_OFFER_RESTRCITED = 'OFFER_RESTRICTED',
  PRIVATE_OFFER_IN_DRAFT = 'OFFER_IN_DRAFT',
  PRIVATE_OFFER_RESTRICTION_IN_PROGRESS = 'OFFER_RESTRICTION_IN_PROGRESS',

  //Microsoft
  OFFER_IN_DRAFT = 'OFFER_IN_DRAFT',
  OFFER_CREATION_IN_PROGRESS = 'OFFER_CREATION_IN_PROGRESS',
  OFFER_CREATION_FAILED = 'OFFER_CREATION_FAILED',
  OFFER_EMAIL_SENT = 'OFFER_EMAIL_SENT',
  OFFER_VIEWED = 'OFFER_VIEWED',
  OFFER_TERMS_ACCEPTED_BUYER = 'OFFER_TERMS_ACCEPTED_BUYER',
  OFFER_PURCHASE_COMPLETE = 'OFFER_PURCHASE_COMPLETE',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  OFFER_EXPIRED = 'OFFER_EXPIRED',
  OFFER_RESTRICTION_IN_PROGRESS = 'OFFER_RESTRICTION_IN_PROGRESS',
  OFFER_RESTRICTED = 'OFFER_RESTRICTED',
}

export enum OfferStageStatus {
  OFFER_CREATION_IN_PROGRESS = 'Created at Labra',
  OFFER_EMAIL_SENT = 'Sent',
  OFFER_VIEWED = 'Viewed',
  OFFER_ACCEPTED = 'Accepted',
}

export enum OfferTypeRenew {
  NEW = 'NEW',
  RENEWAL = 'RENEWAL',
}

export interface StatusOfferResObj {
  'Created at Labra': string
  Sent?: string
  Viewed?: string
  Accepted?: string
}

export enum ProductStatus {
  PRODUCT_STATUS_PUBLIC = 'Public',
  PRODUCT_STATUS_IN_PROGRESS = 'In-progress',
  PRODUCT_STATUS_LABRA_TESTING = 'Labra-testing',
  PRODUCT_STATUS_LIMITED = 'Limited',
  PRODUCT_STATUS_DRAFT = 'Draft',
  PRODUCT_STATUS_CREATION_FAILED = 'Failed',
  PRODUCT_STATUS_AWS_TESTING = 'AWS-testing',
  PRODUCT_STATUS_RESTRICTED = 'Restricted',
  PRODUCT_STATUS_REJECTED = 'Rejected',
  PRODUCT_STATUS_MIGRATION_IN_QUEUE = 'MIGRATION_IN_QUEUE',
  MIGRATION_FAILED = 'MIGRATION_FAILED',
  MIGRATION_IN_PROGRESS = 'MIGRATION_IN_PROGRESS',
}

export interface StatusListingResObj {
  Draft: string
  Limited?: string
  'Labra-testing'?: string
  'AWS-testing'?: string
  Public?: string
  Rejected?: string
  Restricted?: string
}

export enum SubscriptionStatusValue {
  SUBSCRIPTION_PENDING = 'SUBSCRIPTION_PENDING',
  SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS',
  SUBSCRIPTION_FAIL = 'SUBSCRIPTION_FAIL',
  UNSUBSCRIBE_PENDING = 'UNSUBSCRIBE_PENDING',
  UNSUBSCRIBE_SUCCESS = 'UNSUBSCRIBE_SUCCESS',
  SUBSCRIBED = 'SUBSCRIBED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export interface SubscriptionRow {
  entitlementId: string
  entitlementValue: string
  entitlementExpirationDate: string
  dimensionId: string
  dimensionName: string
  dimensionLabel: string
  dimensionLabelDescription: string
  dimensionIsAdditionalUsageAllowed: boolean
  dimensionAdditionalUsageDescription: string
  dimensionValueDataType: string
  meteringTimestamp: string
  meteringId: string
  meteringQuantityConsumed: number
  meteringLastUpdatedAt: string
  meteringStatus: string
}

export interface Entitlement {
  rows: SubscriptionRow[]
}

export interface SubscriptionObject {
  cloudMarketplaceContractId: string
  subscriptionId: string
  awsAgreementId: string
  buyerCompanyName: string
  buyerId: string
  buyerLogoUrl: string
  lastMeteringInfoSentAt: string
  contractStartDate: string
  contractExpirationDate: string
  listingStatus: string
  status: SubscriptionStatusValue
  productType: string
  createdAt: string
  updatedAt: string
  offerType: string
  awsOfferId?: string
  cloudMarketplaceProductId: string
  awsProductUid: string
  productId: string
  productName: string
  productUrl: string
  cloudMarketplace: string
  cloudOfferUrl?: string
  labraOfferUrl?: string
  offerAcceptedAt: string
  renewal: boolean
  entitlement: Entitlement
  privateOfferName?: string
  awsAccountId?: string
  microsoftAccountId?: string
  gcpAccountId?: string
  productStatus?: string
  microsoftOfferId?: string
  creationOrigin?: 'ISV' | 'CP' | null
}

export enum EulaType {
  STANDARD = 'STANDARD',
  ENTERPRISE = 'ENTERPRISE',
  CUSTOM = 'CUSTOM',
  PUBLIC = 'PUBLIC',
}

export enum AzurePricingType {
  LABRA_PERCENTAGE = 'labra_percentage',
  ABSOLUTE = 'absolute',
}

export enum RecurrentPriceModeType {
  FLATRATE = 'flatRate',
  PERUSER = 'perUser',
}

export enum OfferRecurrentPricingType {
  EDITEXISTINGOFFERPRICINGONLY = 'editExistingOfferPricingOnly',
  SAASNEWCUSTOMIZEDPLANS = 'saasNewCustomizedPlans',
  VMSOFTWARERESERVATIONS = 'vmSoftwareReservations',
}

export interface MicrosoftResellerDetails {
  id: string
  partnerName: string
  location?: string
}

export interface Stakeholders {
  firstName: string
  lastName: string
  title: string
  email: string
}

export type AgreementApprovers = {
  hierarchyOrder?: number
  email: string
  name: string
}

export interface CPPOProducts {
  awsProductId: string
  dimensions: Dimension[]
  productName?: string
}

export type FailedErrorMessage = {
  message?: string
}

export interface SubscriptionsAPIResponse {
  pageNumber: number
  pageSize: number
  count: number
  sortBy?: string
  sortOrder?: string
}

export interface OfferRecipients {
  firstName: string
  lastName: string
  title: string
  email: string
  sentAt?: string
  lastViewedAt?: string
  firstViewedAt?: string
  crmObjectId?: string
  name?: string
}

export interface OfferStakeholders {
  name?: string
  firstName: string
  lastName: string
  email: string
}

export type OfferEndBuyers = {
  firstName: string
  lastName: string
  title: string
  email: string
  sentAt?: string
  lastViewedAt?: string
  firstViewedAt?: string
  crmObjectId?: string
  name?: string
}

export interface MetaData {
  crmObjectId?: string
  type?: string
  key: string
  value?: string | null
}

export interface Installments {
  paymentDate: string
  amount?: number | null
  currency: string
  flatFee?: number
  otherAmount?: number | null
  chargeDate?: string
  pricePerPaymentInUsd?: number | null
  isImmediateInstallment?: boolean
  /** Renewal schedule: months after new contract starts */
  monthsAfter?: number
  dayOfMonth?: number
  percentage?: number
}

export interface PriceTypes {
  price1m: number | null
  price12m: number | null
  price24m: number | null
  price36m: number | null
  additionalUsagePrice: number | null
  subscriptionPrice: number | null
  price?: number
}

export type DimensionType = 'standard' | 'custom' | 'additional_usage'

export type Price = number | PriceTypes

export interface Dimension {
  id?: string
  dimensionId?: string
  type: DimensionType
  price?: Price
  prices?: Price
  currency: string
  quantity?: number
  label?: string
  labelDescription?: string
  name?: string
  productName?: string
  awsProductId?: string
  crmObjectId?: string
  isAdditionalUsageAllowed?: boolean
  createdAt?: string
  additionalUsageDescription?: string
  additionalUsagePrice?: number
}

export interface CppoDimension extends Dimension {
  partnerMargin?: number | null
  cppoId?: string | null
}

export interface AzureInstallments {
  schedule?: Installments[]
  tcv?: number
  frequency?: ScheduleType
}

export interface PaymentOption {
  type: string
  value: number
}

export interface AzureRecurrentPriceField {
  pricePerPaymentInUsd?: number
  installments?: AzureInstallments
  billingTerm?: BillingTerm
  paymentOption?: PaymentOption | { type?: string; value?: number }
}

export interface RecurrentPrice {
  recurrentPriceMode?: RecurrentPriceModeType
  priceInputOption?: AzurePriceInputOption
  prices: AzureRecurrentPriceField[]
  userLimits: {
    min?: number
    max?: number
    minEnable?: boolean
    maxEnable?: boolean
  }
}

export interface AdditionalMeter {
  includedQuantities?: IncludedQuantity[]
  pricePerPaymentInUsd?: number
  unitOfMeasure?: string
  meteringDimensionName?: string
  cloudDimensionId?: string
  cloud_dimension_id?: string
  meterType?: string
  meter_type?: string
}

export interface CustomMeters {
  priceInputOption?: AzurePriceInputOption
  meters: {
    [x: string]: AdditionalMeter
  }
}

export interface AzurePOPricing {
  recurrentPrice: RecurrentPrice
  customMeters?: CustomMeters
}

export interface AzureOfferPlan {
  planId?: string
  azurePlanId?: string
  displayName?: string
  labraPlanId?: string
  description?: string
  offerPricingType?: string
  pricing?: AzurePOPricing
  originalPricing?: AzurePOPricing
  discountType?: AzurePricingType
  buyerPrice?: number | null
  discountPercentage?: number | null
  markupPercentage?: number | null
}

export enum CppoPriceAdjustmentType {
  PERCENTAGE = 'discount',
  FIXED = 'markup',
}

export interface CppoStages {
  'Created at Labra'?: string | null
  Sent?: string | null
  Viewed?: string | null
  Cancelled?: string | null
  Accepted?: string | null
}

export enum CppoStageToStatusRelationMapEnum {
  IN_PROGRESS = 'Created at Labra',
  SENT = 'Sent',
  VIEWED = 'Viewed',
  CANCELLED = 'Cancelled',
  ACCEPTED = 'Accepted',
}

export type ChannelPartnerPrivateOfferInCreation = {
  companyName?: string
  awsAccountId?: string
  offerName?: string
  offerExpirationDate?: string | null
  subscriptionEndDate?: string | null
  offerDescription?: string
  offerRecipients?: OfferRecipients[]
  customEmailMessage?: string
  priceAdjustmentType?: CppoPriceAdjustmentType
  adjustmentPercentage?: number
  adjustmentPercentageInputValue?: number
  flexiblePaymentTerms?: boolean
  offerStakeholders?: OfferStakeholders[]
  customOfferStakeholders?: OfferStakeholders[]
  metaData?: MetaData[]
  installments?: Installments[]
  serviceLength?: number
  flexiblePaymentType?: ScheduleType
  dimensions?: CppoDimension[]
  variableStartDate?: boolean
  agreementStartDate?: string | null
  eulaType?: EulaType
  eulaFile?: string[]
  isResellerLicenseAgreementAccepted?: boolean
  draft?: boolean
  previousSubscriptionEndDate?: string
  firstInstallmentDate?: string | null
  labraOfferId?: string
}

export interface ChannelPartnerPrivateOffer {
  id: string
  companyName?: string
  awsAccountId?: string
  resaleAuthorizationId?: string
  offerStatus?: OfferStatus
  subscriptionEndDate?: string
  isvName?: string
  offerStakeholders?: OfferStakeholders[]
  customOfferStakeholders?: OfferStakeholders[]
  customEmailMessage?: string | null
  type?: string | OfferTypeRenew
  offerName?: string
  offerDescription?: string
  offerExpirationDate?: string
  offerUrl?: string
  offerId?: string
  serviceLength?: number
  priceAdjustmentType?: CppoPriceAdjustmentType
  adjustmentPercentage?: number | null
  flexiblePaymentTerms?: boolean
  contractDuration?: number
  eulaType?: EulaType
  eulaFile?: string[]
  offerRecipients?: OfferRecipients[]
  installments?: Installments[]
  awsProductId?: string
  draft?: boolean
  crmObjectId?: string
  cloudProductName?: string
  productType?: string
  createdAt?: string
  updatedAt?: string
  dimensions?: CppoDimension[]
  agreementStartDate?: string
  emailCustomMessage?: string
  cloudOfferId?: string
  labraSubscriptionId?: string
  creationOrigin?: string
  labraResaleAuthorizationId?: string
  labraOfferId?: string
  currency?: string
  cloudOfferUrl?: string
}

export interface MicrosoftOfferStages {
  'Created at Labra'?: string | null
  'Sent to buyer'?: string | null
  'Viewed by buyer'?: string | null
  'Pending purchase'?: string | null
  'Pending account configuration'?: string | null
  Accepted?: string | null
  Expired?: string | null
  'Deactivation in progress'?: string | null
  Deactivated?: string | null
}

export enum MicrosoftOfferStageToStatusRelationMapEnum {
  'offerInDraft' = 'Created at Labra',
  'offerCreationInProgress' = 'Created at Labra',
  'offerCreationFailed' = 'Sent to buyer',
  'offerEmailSent' = 'Sent to buyer',
  'offerViewed' = 'Viewed by buyer',
  'offerTermsAcceptedBuyer' = 'Pending purchase',
  'offerPurchaseComplete' = 'Pending account configuration',
  'offerAccepted' = 'Accepted',
  'offerExpired' = 'Expired',
  'offerRestrictionInProgress' = 'Deactivation in progress',
  'offerRestricted' = 'Deactivated',
}

export type ResaleAuthorizationType = 'CREATED' | 'RECEIVED'

export interface ResaleAuthStages {
  'Authorization created'?: string | null
  'Authorization activated'?: string | null
  'Authorization duration ended'?: string | null
  'Authorization deactivated'?: string | null
  'Authorization completed'?: string | null
  'Channel offer accepted'?: string | null
  'Authorization creation failed'?: string | null
}

export enum ResaleAuthStageToStatusRelationMapEnum {
  CREATED = 'Authorization created',
  ACTIVE = 'Authorization activated',
  EXPIRED = 'Authorization duration ended',
  COMPLETED = 'Authorization completed',
  CHANNEL_OFFER_ACCEPTED = 'Channel offer accepted',
  DEACTIVATED = 'Authorization deactivated',
  FAILED = 'Authorization creation failed',
}

export interface MPPOResaleAuthStages {
  'Created at Labra'?: string | null
  'Sent to reseller'?: string | null
  'Viewed by reseller'?: string | null
  'Extended to buyer'?: string | null
  'Pending purchase'?: string | null
  'Pending account configuration'?: string | null
  Accepted?: string | null
  Expired?: string | null
  'Deactivation in progress'?: string | null
  Deactivated?: string | null
}

export enum MPPOResaleAuthStageToStatusRelationMapEnum {
  'offerInDraft' = 'Created at Labra',
  'offerCreationInProgress' = 'Created at Labra',
  'offerCreationFailed' = 'Sent to reseller',
  'offerSentReseller' = 'Sent to reseller',
  'offerViewedReseller' = 'Viewed by reseller',
  'offerExtendedToBuyer' = 'Extended to buyer',
  'offerTermsAcceptedBuyer' = 'Pending purchase',
  'offerPurchaseComplete' = 'Pending account configuration',
  'offerAccepted' = 'Accepted',
  'offerExpired' = 'Expired',
  'offerRestrictionInProgress' = 'Deactivation in progress',
  'offerRestricted' = 'Deactivated',
}

export enum ResellerAgreementStatus {
  //AWS status
  IN_PROGRESS = 'in_progress',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  COMPLETED = 'completed',
  RESTRICTED = 'restricted',
  DEACATIVATION_IN_PROGRESS = 'deactivation_in_progress',
  DEACATIVATED = 'deactivated',
  FAILED = 'failed',
  DRAFT = 'draft',
  PENDING = 'pending',
  CHANNEL_OFFER_ACCEPTED = 'channel_offer_accepted',

  //Microsoft status
  OFFER_IN_DRAFT = 'OFFER_IN_DRAFT',
  OFFER_CREATION_IN_PROGRESS = 'OFFER_CREATION_IN_PROGRESS',
  OFFER_CREATION_FAILED = 'OFFER_CREATION_FAILED',
  OFFER_SENT_RESELLER = 'OFFER_SENT_RESELLER',
  OFFER_VIEWED_RESELLER = 'OFFER_VIEWED_RESELLER',
  OFFER_EXTENDED_TO_BUYER = 'OFFER_EXTENDED_TO_BUYER',
  OFFER_TERMS_ACCEPTED_BUYER = 'OFFER_TERMS_ACCEPTED_BUYER',
  OFFER_PURCHASE_COMPLETE = 'OFFER_PURCHASE_COMPLETE',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  OFFER_EXPIRED = 'OFFER_EXPIRED',
  OFFER_RESTRICTION_IN_PROGRESS = 'OFFER_RESTRICTION_IN_PROGRESS',
  OFFER_RESTRICTED = 'OFFER_RESTRICTED',
}

export enum AgreementDurationType {
  SINGLE_USE = 'SINGLE_USE',
  SPECIFIC_TIME = 'SPECIFIC_TIME',
  NO_SET_TIME = 'NO_SET_TIME',
}

export enum DiscountType {
  DISCOUNT = 'DISCOUNT',
  INDIVIDUAL_PRICING = 'INDIVIDUAL_PRICING',
  FLEXIBLE_PAYMENT_TERMS = 'FLEXIBLE_PAYMENT_TERMS',
  USAGE_PRICING = 'USAGE_PRICING',
}

export enum ContractDurationType {
  STANDARD = 'standard',
  CUSTOM = 'custom',
}

export type ChannelType = 'EXTERNAL' | 'AWS_MARKETPLACE'

export type InstallmentInfo = {
  amount: number
  buyerAmount?: number
  currency: string
  paymentDate: string
}

export interface Features {
  label: string
  status: string
  value: string
}

export interface BillingTerm {
  type: string
  value: number
}

export interface IncludedQuantity {
  billingTerm: BillingTerm
  isInfinite: boolean
  quantity: number
}

export enum PlanTypeGCP {
  USAGE = 'USAGE',
  FLAT_FEE = 'FLAT_FEE',
  FLAT_FEE_USAGE = 'FLAT_FEE_USAGE',
}

export enum AzurePriceInputOption {
  PERMARKET = 'perMarket',
  USD = 'usd',
}

// NOTE: The full Microsoft listing-data shape lives in the (un-migrated)
// addEditProduct module. It is represented permissively here until that
// module is migrated.
export type FlyoutMicrosoftProductSections = Record<string, unknown>

export interface OffersWithErrors {
  variableStartDate?: boolean
  pricingModel?: string
  [key: string]: unknown
}

export interface Product {
  productId: string
  productName: string
  productType?: PlanType
  [key: string]: unknown
}

export enum FlyoutOnboardingSectionName {
  PAGE_MARKER = 'pageMarker',
  LABRA_PARTNER_DETAILS = 'labraPartnerDetails',
  CLOUD_SETTINGS = 'cloudSettings',
  TERMS_AND_CONDITIONS = 'termsAndConditions',
  LOCK_METADATA = 'lockMetadata',
  GENERAL_INFORMATION = 'generalInformation',
  LANDING_PAGE_DETAILS = 'infoCollectionFormMetaData',
}

export type Sections = {
  [FlyoutOnboardingSectionName.PAGE_MARKER]?: Record<string, boolean>
}

export interface MicrosoftOnboarding {
  filledCloudSettings?: boolean
  filledCompanyInfo?: boolean
}

export interface FlyOutListingData {
  onboarded?: boolean
  countryRegistered?: string
  currencies?: string[]
  origin?: string
  awsAccountId?: string
  awsAccountName?: string
  sellerType?: string[]
  sellerMetadata?: {
    awsRoleArn?: string
    awsCasS3BucketName?: string
    awsKmsKeyArn?: string
    awsCasSnsTopic?: string
  }
  isOwnS3Bucket?: boolean
  stackType?: 'cloudformation' | 'terraform'
  cloudExternalId?: string
  terraformConnectionValidated?: boolean
}

export interface MicrosoftFlyOutListingData {
  onboarded?: boolean
  currencies?: string[]
  sellerName?: string
}

export interface FieldMetadataField {
  readOnly: boolean
  hidden: boolean
}

export interface FieldMetadataMetaData {
  key?: string
  value?: string
  readOnly: boolean
  hidden: boolean
  index?: number
}

export type FieldMetadata = Record<
  string,
  FieldMetadataField | FieldMetadataMetaData[] | Record<string, unknown>
>

export enum EntitlementOption {
  SINGLE = 'SINGLE',
  MANY = 'MANY',
}

export type {
  PrivateOffer,
  GCPOfferPlan,
  GCPOfferPlanDimesnion,
  GCPInstallments,
  InstallmentSchedule,
  creatorData,
  MicrosoftPOResaleAuthAuditJson,
  dealType,
  AuditJson,
  ErrorDetails,
} from './privateOffer'
